<template>
  <div class="app">
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>

    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('Centre-Identification') }}  </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search3"
               :label="this.$t('Search')"
              append-icon="search"
            >
            </v-text-field>

            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Save"
                slot="activator"
                @click="insertMerkezOpen()"
                flat
              >
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('CENTER')}) }} </span>
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('CENTER')}) }}</span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headersMerkez"
        :rows-per-page-items="[50, 100]"
        :loading="progress"
        :items="items"
        :search="search3"
      >
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr item>
            <td class="text-xs-left">{{ props.item.ID }}</td>
            <td class="text-xs-left">{{ props.item.CenterName }}</td>
            <td class="justify-end align-center full-heigth layout px-0">
              <v-btn
                v-if="sayfayetki.Update"
                @click="editDialogOpen(props.item)"
                icon
                small
                flat
              >
                <v-icon color="info">search</v-icon>
              </v-btn>
              <v-btn
                v-if="sayfayetki.Delete"
                @click="deleteDialogOpen(props.item)"
                icon
                small
                flat
              >
                <v-icon color="warning">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>

    <v-dialog v-model="editDataDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">Merkez Düzenle</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field
            v-model="merkezLoadData.CenterName"
            :label="$t('Centre-Name')"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="editDataDialog = false" outline color="warning">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn outline color="info" @click="UpdateSirket()"> {{ $t('Update') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="insertDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">{{ $t('Add-v2', { value: $t('CENTER')}) }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field
            v-model="merkezData.CenterName"
            :label="$t('Centre-Name')"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="insertDialog = false" outline color="warning">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn outline color="info" @click="insertMerkez()"> {{ $t('save_button') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-toolbar color="warning">
        <v-toolbar-title class="white-text">
          <span class="white--text">Merkez Sil</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text class="blockquote">
          {{ $t('Are-you-sure-want-delete') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" outline color="warning">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn outline color="info" @click="deleteMerkez()">  {{ $t('Delete') }}  </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tool from "@/components/app/coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import auth from "@/api/auth";
import loadingcomp from "@/components/app/customcomp/loadingcomp";

export default {
  data() {
    return {
      loadingvmodel: false,
      editDataDialog: false,
      insertDialog: false,
      deleteDialog: false,
      deleteData: {
        ID: 0,
        CenterName: null,
      },
      text1: null,
      snackbar: false,
      yetkidialog: false,
      headersMerkez: [
        {
          text: "ID",
          value: "ID",
          align: "left",
        },
        {
          text: this.$t('Centre-Name'),
          value: "CenterName",
          align: "left",
        },
      ],
      merkezData: {
        ID: 0,
        CenterName: null,
      },
      merkezLoadData: {
        ID: 0,
        CenterName: null,
      },
      loading: false,
      progress: false,
      items: [],
      search3: "",
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
    };
  },
  components: {
    tool,
    yetkidialog,
    snackbarcomp,
    loadingcomp,
  },
  methods: {
    deleteDialogOpen(val) {
      this.deleteDialog = true;
      this.deleteData = val;
    },
    deleteMerkez() {
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCenterDelete",
          this.deleteData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.text1 = this.$t('Update-completed');
            this.snackbar = true;
            this.deleteDialog = false;
            this.loadingvmodel = false;
            this.getMerkezList();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCenterDelete";
              this.snackbar = true;
              this.deleteDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCenterDelete";
              this.snackbar = true;
              this.deleteDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    insertMerkez() {
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCenterSave",
          this.merkezData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.text1 = this.$t('Update-completed');
            this.snackbar = true;
            this.insertDialog = false;
            this.loadingvmodel = false;

            this.getMerkezList();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCompanySave";
              this.snackbar = true;
              this.insertDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCompanySave";
              this.snackbar = true;
              this.insertDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    insertMerkezOpen() {
      this.merkezData.CenterName = null;
      this.insertDialog = true;
    },
    UpdateSirket() {
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCenterSave",
          this.merkezLoadData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.text1 = this.$t('Update-completed');
            this.snackbar = true;
            this.getMerkezList();
            this.editDataDialog = false;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCenterSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCenterSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    editDialogOpen(val) {
      var params = {
        ID: val.ID,
        CenterName: val.CenterName,
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCenterLoad",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.merkezLoadData = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCompanyLoad";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-AccountingCompanyLoad";
              this.snackbar = true;
            }
          }
        );
      this.editDataDialog = true;
    },
    getMerkezList() {
      var params = {};
      let muhasebePrms= {
        CompanyId  : this.credentials.MuhasebeSirketNo
        }
        params=muhasebePrms;
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCenterList",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.items = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.getMerkezList();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
};
</script>

<style>
</style>